<template>
  <v-dialog
    v-model="isModalShow"
    persistent
    max-width="600"
  >
    <v-card>
      <v-card-title class="headline">Session was changed</v-card-title>

      <v-card-text>
        This session was removed from web portal. You can add it in 'agenda/settings'
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="green darken-1"
          flat="flat"
          @click="preparePayload"
        >
          Agree
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import moment from 'moment'
  import { clone, path, } from 'ramda'

  export default {
    name: 'DisplayAgendaSettings',
    props: {
      id: {
        type: String,
        default: ''
      },
      isModalShow: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        displayAgendaSettings: null
      }
    },
    computed: {
      ...mapGetters([
        'agendaSetting',
        'sessionsListState'
      ]),
      isRelated () {
        return !!path([this.id, 'location'], this.sessionsListState)
      },

    },
    methods: {
      ...mapActions([
        'fetchGeneralSettings',
        'editSettings'
      ]),
      async preparePayload () {
        if(!this.id) {
          this.$emit('displayAgendaSettings')
          return
        }
        const timeKey = moment(path([this.id, 'time'], this.sessionsListState)).utc().format('DD-MM-YYYY')
        const locationId = path([this.id, 'location'], this.sessionsListState)
        if(this.isRelated) {
          this.displayAgendaSettings.displaySettingsObject[timeKey].forEach(el => {
            if (el.locationType === "related") {
              el.sessions[locationId].forEach((el, i, arr) => {
                if (el.id === this.id) {
                  arr.splice(i, 1)
                }
              })
            }
          })

        } else {
          this.displayAgendaSettings.displaySettingsObject[timeKey].forEach((el, i, arr) => {
            if (el.locationType === "unrelated" && el.sessions === this.id) {
              arr.splice(i, 1)
            }
          })
        }
        this.$emit('displayAgendaSettings')
        await this.editSettings(this.displayAgendaSettings)
      }
    },
    async beforeMount () {
      if (!this.agendaSetting) {
        await this.fetchGeneralSettings()
      }
      this.displayAgendaSettings = clone(this.agendaSetting)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/shared/DisplayAgendaSettings/index.vue